function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 385 385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M367.038 67.8c-6.73 4.089-13.5 5-20.041 6.115-10.009 1.7-16.125 2.362-27.463 6.109a99.77 99.77 0 0 0-22.546 10.643 86.017 86.017 0 0 1 25.557-15.939c11.53-4.563 18.447-5.62 28.588-9.113 7.345-2.53 12.625-5.047 17.383-9.3 2.174-12.605 10.631-29.227 10.631-29.227-98.2 0-183.743 88.6-183.743 186.8 0 0 3.761-17.839 11.64-30.473 4.79-7.681 12.957-18.478 23.233-26.593 10.557-8.336 27.655-16.812 37.106-19.413 23.834-6.558 40.182-4.4 55.284-8.662 12.982-3.66 29.313-12.077 37.113-28.809 4.813-10.327 5.82-19.538 7.258-32.138Z",
    style: {
      fill: "#000"
    },
    "data-name": "Layer 5"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.132 192.5A93.368 93.368 0 0 0 192.5 99.132V0C86.185 0 0 86.185 0 192.5Z",
    style: {
      fill: "#848dd3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.5 285.868a93.368 93.368 0 0 1 93.368-93.368H385C385 298.815 298.815 385 192.5 385Z",
    style: {
      fill: "#dd2828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.132 192.5a93.368 93.368 0 0 1 93.368 93.368V385C86.185 385 0 298.815 0 192.5Z",
    style: {
      fill: "#f9e99b"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlack);
export default __webpack_public_path__ + "static/media/black.201cf91549c3a00fb9aecc04bad1c3ff.svg";
export { ForwardRef as ReactComponent };